/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Flex,
    Stack,
    Box,
    Text,
    TabPanels,
    TabPanel,
    Position
} from '@locus-taxy/neo-ui';

import { JsonFormsDispatch } from '@jsonforms/react';
import { rankWith, uiTypeIs } from '@jsonforms/core';

import useLayoutProps from '../util/useLayoutProps';
import useGetVisibleTabProps from '../util/useGetVisibleTabProps';
import useActiveState from '../util/useActiveState';

type Props = {};

const VerticalTabLayoutRenderer = (props: Props): React.Node => {
    const {
        uischema,
        schema,
        path,
        visible,
        renderers,
        cells,
        enabled
    } = useLayoutProps(props);

    const visibleTabs = useGetVisibleTabProps({
        uischema,
        schema,
        path
    });

    const [activeTab, setActiveTab] = useActiveState({
        name: 'module',
        tabs: uischema.elements
    });

    const { t } = useTranslation('platform');

    return (
        visible && (
            <Flex>
                <Position position="fixed">
                    <Box width="200px" height="100%" mr={4}>
                        <Stack>
                            {visibleTabs.map((e, index) => (
                                <Box
                                    key={index}
                                    padding={3}
                                    onClick={() => setActiveTab(index)}
                                    backgroundColor={
                                        activeTab === index
                                            ? 'blue.100'
                                            : 'current'
                                    }
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <Text
                                        fontSize={1}
                                        color={
                                            activeTab === index
                                                ? 'grey.900'
                                                : 'grey.600'
                                        }
                                    >
                                        {t(e.uischema.label)}
                                    </Text>
                                </Box>
                            ))}
                        </Stack>
                    </Box>
                </Position>
                <Box width="1000px" marginLeft="200px">
                    <TabPanels value={activeTab} renderActiveOnly>
                        {visibleTabs.map((e, index) => (
                            <TabPanel key={index} value={index} padding={4}>
                                {e.uischema.elements.map((element, index) => (
                                    <div key={`${path}-${index}`}>
                                        <JsonFormsDispatch
                                            uischema={element}
                                            schema={schema}
                                            path={path}
                                            enabled={enabled}
                                            renderers={renderers}
                                            cells={cells}
                                        />
                                    </div>
                                ))}
                            </TabPanel>
                        ))}
                    </TabPanels>
                </Box>
            </Flex>
        )
    );
};

export default VerticalTabLayoutRenderer;

export const verticalTabLayoutTester = rankWith(
    1,
    uiTypeIs('VerticalTabLayout')
);
